import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { Routes, Route } from 'react-router-dom';
import Error from 'pages/Error';
import { useQueryParams } from 'hooks';
import { Composer } from 'ui/partials';
import { COMPOSER_TYPES } from 'utils/constants';

import Tasks from './Tasks';
import ArchivedTasks from './ArchivedTasks';

const ROUTES = [
  {
    path: '/archived',
    element: () => <ArchivedTasks />,
  },
  {
    path: '/',
    element: () => <Tasks />,
  },
];

interface CONTEXT {
  selectedTaskId?: string | null;
  selectedNodeId?: string | null;
  setSelectedTaskId?: Dispatch<SetStateAction<string | null>>;
  clearTaskId?: () => void;
  setSelectedNoteId?: Dispatch<SetStateAction<string | null>>;
}

export const TasksContext = createContext<CONTEXT>({
  selectedTaskId: '',
});
// eslint-disable-next-line react-refresh/only-export-components
export const useTasksContext = () => useContext(TasksContext);

const _Tasks = () => {
  const [params] = useQueryParams();
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null);

  useEffect(() => {
    if (params?.selectedTask) {
      setSelectedTaskId(params.selectedTask as string);
    }
  }, [params?.selectedTask]);

  const value = useMemo(
    () => ({
      selectedTaskId,
      setSelectedTaskId,
      clearTaskId: () => setSelectedTaskId(null),
      setSelectedNoteId: () => {},
    }),
    [selectedTaskId, setSelectedTaskId],
  );

  return (
    <TasksContext.Provider value={value}>
      <Routes>
        {ROUTES.map(({ path, element }) => (
          <Route key={Math.random()} path={path} element={element()} />
        ))}
        <Route path="*" element={<Error />} />
      </Routes>
      <Composer
        type={COMPOSER_TYPES.task}
        onSubmit={async () => {}}
        closeComposer={() => setSelectedTaskId(null)}
        isOpen={!!selectedTaskId}
      />
    </TasksContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export default _Tasks;
